import Login from "./screens/Login";

function UnauthenticatedApp() {
  return <Login />;
}

export default UnauthenticatedApp;
